import { Box, Flex, Heading } from '@chakra-ui/react';
import Typewriter from 'typewriter-effect';
import './styles/app.css';

const portrait = `${process.env.PUBLIC_URL}/profile/profile.svg`;

export default function name() {
  return (
    <Box className="landing-page">
      <Flex
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
        gap={{ base: 8, md: 10 }}
      >
        <Box>
          <Heading
            size={'3xl'}
            bgGradient="linear(to-br, brand.200, brand.500 60%, #b98a3c)"
            bgClip="text"
            fontSize={{ base: '4xl', md: '6xl' }}
            fontWeight="extrabold"
          >
            Warodom Baiudom
          </Heading>
          <Heading
            size={{ base: 'lg' }}
            fontFamily="mono"
            fontWeight={400}
            color="ink-soft"
            whiteSpace="nowrap"
          >
            <Typewriter
              loop={true}
              onInit={typewriter => {
                typewriter
                  .typeString('Hello, World!')
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("I'm Champ")
                  .start();
              }}
            />
          </Heading>
        </Box>
        {/* Portrait leads on mobile, sits beside the name from md up */}
        <Box className="hero-portrait" order={{ base: -1, md: 0 }}>
          <img src={portrait} alt="Warodom Baiudom" />
        </Box>
      </Flex>
    </Box>
  );
}
